module.exports = __webpack_public_path__ + "static/media/watercooler-mob-2x.94755f47.png";